import {
    getProjectRoleScopeIds,
    hasWorkspaceWideProjectAccess,
    resolveProjectAccess,
} from "./project-access";

export function buildMyProjectsScopeFilter(workspace, membership, userRoles) {
    const workspaceId = typeof workspace === "object"
        ? workspace?.id ?? workspace?.documentId
        : workspace;
    const membershipDocumentId = typeof membership === "object"
        ? membership?.documentId
        : membership;
    const roles = Array.isArray(userRoles) ? userRoles : membership?.user_roles || [];

    if (!workspaceId || !membershipDocumentId) return null;

    const filters = [
        {workspace: {$eq: workspaceId}},
        {archivedAt: {$null: true}},
    ];

    if (!hasWorkspaceWideProjectAccess(roles)) {
        const projectRoleScopeIds = getProjectRoleScopeIds(roles, workspace, membership);
        const numericScopeIds = projectRoleScopeIds
            .filter((scopeId) => /^\d+$/.test(scopeId))
            .map(Number);
        const accessBranches = [
            {members: {documentId: {$eq: membershipDocumentId}}},
            {owner: {documentId: {$eq: membershipDocumentId}}},
        ];
        if (projectRoleScopeIds.length) {
            accessBranches.push({documentId: {$in: projectRoleScopeIds}});
        }
        if (numericScopeIds.length) {
            accessBranches.push({id: {$in: numericScopeIds}});
        }
        filters.push({
            $or: accessBranches,
        });
    }

    return {$and: filters};
}

export function isProjectInMyProjectsScope(project, workspace, membership, userRoles) {
    return resolveProjectAccess({
        workspace,
        activeMembership: membership,
        userRoles,
        project,
    }).canViewProject;
}

export function filterMyProjectsScope(projects, workspace, membership, userRoles) {
    return (Array.isArray(projects) ? projects : [])
        .filter((project) => isProjectInMyProjectsScope(
            project,
            workspace,
            membership,
            userRoles,
        ));
}
